import React, { useEffect, useRef, useState, useMemo } from 'react';
import whatsappBg from "../../../assets/images/whatsapp-bg.jpg";
import { Phone, ExternalLink, Copy, MessageSquare } from 'lucide-react';

const TemplatePreview = React.memo(({ headerType, headerText, headerMedia, variable, body, buttons, imageUrl }) => {
  const [isLoading, setIsLoading] = useState(false);
  console.log('TemplatePreview data-------------:', { headerType, headerText, headerMedia, variable, body, buttons, imageUrl });

 
  const formattedBody = useMemo(() => {
    if (!body) return "_Preview of your message_";
    
  
    
    let formattedText = body;
    
    formattedText = formattedText.replace(/<strong\s*?>(.*?)<\/strong>/gi, '*$1*');
    formattedText = formattedText.replace(/<b\s*?>(.*?)<\/b>/gi, '*$1*');
    formattedText = formattedText.replace(/<em\s*?>(.*?)<\/em>/gi, '_$1_');
    formattedText = formattedText.replace(/<i\s*?>(.*?)<\/i>/gi, '_$1_');
    formattedText = formattedText.replace(/<strike\s*?>(.*?)<\/strike>/gi, '~$1~');
    formattedText = formattedText.replace(/<del\s*?>(.*?)<\/del>/gi, '~$1~');
    formattedText = formattedText.replace(/<code\s*?>(.*?)<\/code>/gi, '`$1`');
    
    // Handle paragraph breaks - preserve spacing for preview
    formattedText = formattedText.replace(/<\/p>/gi, '\n\n');
    formattedText = formattedText.replace(/<p\s*?>/gi, '');
    
  
    formattedText = formattedText.replace(/<br\s*?\/?>/gi, '\n');
    formattedText = formattedText.replace(/<\/br>/gi, '\n');
    
 
    formattedText = formattedText.replace(/<div\s*?>/gi, '');
    formattedText = formattedText.replace(/<\/div>/gi, '\n');
    
   
    formattedText = formattedText.replace(/\r?\n/g, '\n');
    
  
    formattedText = formattedText.replace(/<[^>]*>/gm, '');
    

    formattedText = formattedText.replace(/&nbsp;/g, ' ');
    formattedText = formattedText.replace(/&amp;/g, '&');
    formattedText = formattedText.replace(/&lt;/g, '<');
    formattedText = formattedText.replace(/&gt;/g, '>');
    formattedText = formattedText.replace(/&quot;/g, '"');
    formattedText = formattedText.replace(/&#39;/g, "'");
    
 
    formattedText = formattedText.trim();
    
    // console.log('Formatted body:', formattedText);
    // console.log('Formatted body length:', formattedText.length);
    // console.log('Formatted body contains \\n:', formattedText.includes('\n'));
    // console.log('Formatted body contains \\r\\n:', formattedText.includes('\r\n'));
    
    return formattedText;
  }, [body]);

  // Memoize variable display to prevent unnecessary re-renders
  const variableDisplay = useMemo(() => {
    if (variable === 'name') return 'John Doe';
    if (variable === 'date') return new Date().toLocaleDateString();
    if (variable === 'location') return 'New York';
    return '';
  }, [variable]);

  // Generate time for display
  const timeString = useMemo(() => {
    const now = new Date();
    return `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
  }, []);

  return (
    <div className="w-full">
      <div
        className="rounded overflow-hidden relative flex justify-end p-2"
        style={{
          backgroundImage: `url(${whatsappBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '170px'
        }}
      >
        <div className="bg-white p-2 rounded-lg shadow-sm max-w-[95%] relative min-h-[80px] hover:shadow-md transition-shadow duration-200 border border-gray-100">
          {/* WhatsApp message header with business name */}
          <div className="flex items-center text-[11px] text-green-600 font-medium mb-2">
           
            <span className="text-blue-950">Build<span className="text-flamingo-500">Vizer</span></span>
          </div>
          
          {/* Header Display (Image, Video, Document, or fallback) */}
          {headerType === 'image' && imageUrl ? (
            <div className="relative">
              {isLoading ? (
                <div className="animate-pulse bg-gray-200 rounded-md mb-2 h-24"></div>
              ) : (
                <div className="w-full mb-2 rounded-md overflow-hidden h-28">
                  <img
                    src={imageUrl}
                    alt="Header"
                    className="w-full h-full object-cover"
                    style={{ display: 'block' }}
                    onError={(e) => {
                      console.error('Image failed to load:', e);
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              )}
            </div>
          ) : headerMedia?.content && headerMedia?.content_type ? (
            <div className="relative">
              {isLoading ? (
                <div className="animate-pulse bg-gray-200 rounded-md mb-2 h-24"></div>
              ) : (
                <div className="w-full mb-2 rounded-md overflow-hidden h-28">
                  <img
                    src={`data:${headerMedia.content_type};base64,${headerMedia.content}`}
                    alt="Header"
                    className="w-full h-full object-cover"
                    style={{ display: 'block' }}
                    onError={(e) => {
                      console.error('Image failed to load:', e);
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              )}
            </div>
          ) : headerType === 'video' && imageUrl ? (
            <video controls className="max-w-full h-auto rounded-md mb-2 max-h-28">
              <source src={imageUrl} type={headerMedia?.file?.type} />
              Your browser does not support video.
            </video>
          ) : headerType === 'doc' && imageUrl ? (
            <div className="flex items-center bg-gray-100 rounded-md p-2 mb-2">
              <ExternalLink size={14} className="mr-2 text-blue-600" />
              <p className="text-xs text-gray-700 truncate">
                {headerMedia?.file?.name || "Document.pdf"}
              </p>
            </div>
          ) : headerType === 'text' && headerText ? (
            <div className="text-sm font-medium text-gray-800 mb-1">
              {headerText}
            </div>
          ) : null}

          {/* Message Body */}
          <div 
            className="text-sm text-gray-700 break-words whitespace-pre-wrap"
            style={{ whiteSpace: 'pre-wrap' }}
            dangerouslySetInnerHTML={body ? { __html: body } : { __html: '_Preview of your message_' }}
          />

          {/* Preview Buttons */}
          {buttons && buttons.length > 0 && (
            <div className="mt-3 pt-2 border-t border-gray-200">
              <div className="flex flex-col items-center space-y-1.5 w-full">
                {buttons.map((button, index) => {
                  let buttonText = button.buttonText || button.text || "Button";
                  let icon = null;

                  if (button.typeOfAction === 'visit_website' || button.type === 'visit_website') icon = <ExternalLink className="w-3.5 h-3.5" />;
                  if (button.typeOfAction === 'call_phone_number' || button.type === 'call_phone_number') icon = <Phone className="w-3.5 h-3.5" />;
                  if (button.typeOfAction === 'copy_offer_code' || button.type === 'offer_code') icon = <Copy className="w-3.5 h-3.5" />;

                  return (
                    <button
                      key={index}
                      className="flex items-center justify-center gap-1.5 text-xs bg-flamingo-100 text-flamingo-500 font-medium py-1.5 px-3 w-full hover:bg-gray-50 rounded transition border border-gray-200"
                    >
                      {icon}
                      <span className="truncate">{buttonText}</span>
                    </button>
                  );
                })}
              </div>
            </div>
          )}

          {/* Time stamp */}
          <div className="flex items-center justify-end mt-1">
            <span className="text-[10px] text-gray-500">{timeString}</span>
          </div>
        </div>
      </div>
    </div>
  );
});

export default TemplatePreview;